// 提供区分国家版本的工具
/**
 * 国家对应域名，国际版为GLOBAL
 */
export const COUNTRY_DOMAIN_MAP = {
  GLOBAL: process.env.DOMAIN,
  // CN: process.env.DOMAIN_CN,
  VN: process.env.DOMAIN_VN,
}
export type CountryDomainMap = typeof COUNTRY_DOMAIN_MAP
export type CountryVersion = keyof CountryDomainMap
export type CountryVersionMap<T> = Partial<Record<CountryVersion, T>>

interface Config {
  /** 特定国家的i18n地址 */
  i18n?: string
  lang?: string
  imgs?: Record<string, string>
  /** 轨迹域名 */
  tracking?: string
  countryCode?: string
  captchaScene?: string
  /** 统一账号appid */
  account_appId?: string
}

/** 当前国家版本名 */
export const countryVersion = (Object.keys(COUNTRY_DOMAIN_MAP).find((key) => COUNTRY_DOMAIN_MAP[key]?.includes(window.location.host)) ?? 'GLOBAL') as CountryVersion

/**
 * 当前存在的特定国家版本号
 */
export const exceptCountries = Object.keys(COUNTRY_DOMAIN_MAP).filter((k) => k !== 'GLOBAL') as Exclude<CountryVersion, 'GLOBAL'>[]

// function importImgs(r) {
//   const map = {}
//   r.keys().forEach((key) => (map[key] = r(key)))
//   return map
// }

/**
 * 版本名映射国家配置
 */
const COUNTRY_CONFIG: CountryVersionMap<Config> = {
  GLOBAL: {},
  VN: {
    countryCode: 'VN',
    captchaScene: 'oneclub',
    account_appId: 'osvn',
    tracking: 'oneclub.vn',
  },
}

export const countryPick = <T>(obj: CountryVersionMap<T>): T => {
  return obj[countryVersion] ?? obj[''] ?? obj['GLOBAL']
}

/** 当前版本特殊配置 */
export const countryConfig = countryPick(COUNTRY_CONFIG)

/**
 * 引用不同国家版本图片
 * @param url
 * @returns
 */
export const imgURL = (url: string) => {
  return countryConfig.imgs?.[url] ?? null
}

/**
 * 判断当前代码所属国家版本
 */
export const countryIs = Object.keys(COUNTRY_DOMAIN_MAP).reduce((p, key) => {
  p[key] = countryVersion === key
  return p
}, {}) as Required<CountryVersionMap<boolean>>

/** 本土站点 */
export const localCountries = Object.keys(COUNTRY_DOMAIN_MAP).filter((item) => item !== 'GLOBAL' && item !== 'CN')

/**
 * 国家对应pc域名，国际版为GLOBAL
 */
export const PC_COUNTRY_DOMAIN_MAP = {
  GLOBAL: process.env.PC_DOMAIN,
  CN: process.env.PC_DOMAIN_CN,
  VN: process.env.PC_DOMAIN_VN,
}
